import { useEffect } from "react";
import useUnmountComponent from "./useUnmountComponent";

export default function ({
  backgroundRef,
  modalRef,
  unmount,
  fadeIn,
  fadeOut
}) {
  const closeModal = () => {
    backgroundRef.current.classList.remove(fadeIn);
    backgroundRef.current.classList.add(fadeOut);
  };

  useUnmountComponent(modalRef, closeModal);

  useEffect(() => {
    const handleAnimationEnd = () => {
      if (backgroundRef.current.classList.contains(fadeOut)) {
        unmount && unmount();
      }
    };

    const modalElement = backgroundRef.current;
    modalElement.addEventListener("animationend", handleAnimationEnd);

    return () => {
      modalElement.removeEventListener("animationend", handleAnimationEnd);
    };
  }, [unmount]);

  return closeModal;
}
